import httpClient from '~/http';
import { ApiResponse, User } from '@restaurant/types';

export type ProfileResponse = ApiResponse<User>;

export const fetchProfile = () => {
  return httpClient.get<ProfileResponse>('/api/v1/user/me');
};
